import { useRef, useState, useEffect } from "react";

/**
 * useEffect for sizeSreen
 * @param {IntersectionObserverInit} options options of intersection observer
 * * @returns {ref} containerRef is the ref to assign to the element to observe
 * * @returns {boolean} isVisible is the element visible on the wiewport?
 */

const useElementOnScreen = (options) => {
  const containerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [isUp, setIsUp] = useState(false);

  const callbackFunction = (entries) => {
    const [entry] = entries;
    setIsUp(containerRef?.current?.getBoundingClientRect()?.top < 0 ?? false);
    setIsVisible(entry.isIntersecting);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(callbackFunction, options);
    if (containerRef.current) observer.observe(containerRef.current);

    return () => {
      if (containerRef.current) observer.unobserve(containerRef.current);
    };
  }, [containerRef, options]);

  return [containerRef, isVisible, isUp];
};

export default useElementOnScreen;
